<template>
	<div class="d-flex flex-column ao-previev-collapse-item mt-4">
		<div
			class="d-flex align-center ao-text-secondary-color-700 mb-4"
			style="cursor: pointer"
			@click="toggleShowContent()"
		>
			<slot name="icon" />
			<slot name="title">
				<div class="text-textSecondary700 ao-p2-medium text-uppercase">
					{{ title }}
				</div>
			</slot>
			<v-spacer />
			<span class="collapse-icon-background">
				<ao-icon
					iconName="groupOpen"
					size="small"
					class="ao-previev-collapse-item-icon text-textSecondary700"
					:class="{ rotated: showContentDefault }"
				/>
			</span>
		</div>
		<div
			ref="CollapseContent"
			class="ao-previev-collapse-item-content"
			:class="contentClass"
			:style="`transition: max-height linear ${transitionDuration}s;`"
		>
			<div
				v-if="isLoading"
				class="w-100 d-flex align-center justify-center"
				style="height: 8rem;"
			>
				<v-progress-circular
					indeterminate
					color="primary"
					width="3"
					size="48"
				/>
			</div>
			<template v-else>
				<slot
					v-if="initedComponent"
					name="default"
				/>
			</template>
		</div>
		<slot name="divider">
			<v-divider />
		</slot>
	</div>
</template>
<script>
export default {

	name: 'PreviewCollapse',

	props: {
		title: String,
		showContent: {
			type: Boolean,
			default: true,
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		contentClass: {
			type: String,
			default: '',
		},
	},

	data: () => ({
		showContentDefault: false,
		transitionDuration: 0.3,
		initedComponent: false,
	}),

	methods: {

		openCollapse() {
			/*
				- установить maxHeight = 0
				- определить нужную высоту
				- установить ее в качестве maxHeight
				- через 0.3 сек убрать
			*/
			this.$refs.CollapseContent.style.maxHeight = '0px'

			const maxHeight = this.$refs.CollapseContent.scrollHeight
			this.$refs.CollapseContent.style.maxHeight = `${maxHeight}px`
			this.showContentDefault = true

			setTimeout(() => {
				this.$refs.CollapseContent.style.maxHeight = null
			}, this.transitionDuration * 1000)
		},

		closeCollapse() {
			/*
				- определить текущую высоту
				- установить ее в качестве maxHeight
				- установить maxHeight = 0
				- через 0.3 сек убрать
			*/
			const maxHeight = this.$refs.CollapseContent.scrollHeight
			this.$refs.CollapseContent.style.maxHeight = `${maxHeight}px`

			setTimeout(() => {
				this.$refs.CollapseContent.style.maxHeight = '0px'
				this.showContentDefault = false
			}, 0)
		},

		toggleShowContent() {
			this.showContentDefault ? this.closeCollapse() : this.openCollapse()
		},

		// callMaxHeight() {
		// 	this.$nextTick(() => {
		// 		if (this.showContentDefault) {
		// 			this.$refs.CollapseContent.style.maxHeight = `${this.$refs.CollapseContent.scrollHeight}px`
		// 		} else {
		// 			this.$refs.CollapseContent.style.maxHeight = '0px'
		// 		}
		// 	})
		// },
	},

	mounted() {
		this.showContentDefault = this.showContent
		this.$refs.CollapseContent.style.maxHeight = this.showContentDefault ? null : '0px'
		this.initedComponent = true
	},

}
</script>

<style scoped lang="scss">
.ao-previev-collapse-item {
	width: 100%;
	.collapse-icon-background {
		background: #d9e4ec;
		border-radius: 50%;
		width: 16px;
		height: 16px;
		color: rgb(var(--v-theme-primary));
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.ao-previev-collapse-item-icon {
		height: 10px;
		transition: transform 0.3s ease-out;
		transform: rotate(90deg) scale(1, 1);
		display: flex;
		padding-bottom: 9.5px;
		&.rotated {
			transform: rotate(90deg) scale(-1, 1);
		}
	}
	&-content {
		overflow: hidden;
	}
}
</style>
